import React, { useState, useEffect } from 'react'
import ReactPaginate from 'react-paginate'
//import { useSelector } from 'react-redux'

function FilterPagination({
	pagination = { 'size': 20 },
	paginate,
	showPageSizeSelect = false,
	pageSizeOptions = [],
	onPageSizeChange,
	marginPagesDisplayed = 3,
	pageRangeDisplayed = 3,
}) {
	//const settings = useSelector(state => state.settings)

	const [pageCount, setPageCount] = useState(0)
	const [inputPage, setInputPage] = useState(0)
	const [currentPage, setCurrentPage] = useState(0)

	async function getCurrentPage(pageNumber) {
		setCurrentPage(pageNumber.selected)
		paginate(pageNumber.selected)
	}

	function handlePageClick() {
		const newPage = parseInt(inputPage)

		if (newPage >= 1) {
			setCurrentPage(newPage - 1)
			getCurrentPage({ 'selected': newPage - 1 })
		}
	}

	function handlePageSizeChange(e) {
		if (typeof onPageSizeChange === 'function') {
			onPageSizeChange(Number(e.target.value))
		}
	}

	useEffect(() => {
		var size = 20
		if (pagination.size) size = pagination.size
		if (pagination?.response) {
			setPageCount(Math.ceil(pagination?.response?.total / size))
		}
	}, [pagination]) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		const url = pagination?.url || ''
		const pageMatch = url.match(/[?&]page=(\d+)/)
		const pageFromUrl = pageMatch ? Number(pageMatch[1]) : 0
		const normalizedPage = Number.isFinite(pageFromUrl) && pageFromUrl >= 0 ? pageFromUrl : 0

		setCurrentPage(normalizedPage)
		setInputPage(normalizedPage + 1)
	}, [pagination?.url])

	return (
		<>
			{(pageCount > 1 || (showPageSizeSelect && pageSizeOptions.length > 0)) &&
				<div className="d-flex">
					<div className="pagination position-relative">
						{showPageSizeSelect && pageSizeOptions.length > 0 &&
							<select
								className="pagination-size-select"
								value={pagination.size || 20}
								onChange={handlePageSizeChange}>
								{pageSizeOptions.map(option => (
									<option key={option.id} value={option.id}>
										{option.name}
									</option>
								))}
							</select>
						}
						{pageCount > 1 &&
							<>
								<input type="number" className="pagination-input"
									value={inputPage}
									onChange={(e) => setInputPage(e.target.value)}
									onKeyUp={(event) => {
										if (event.key === 'Enter') {
											handlePageClick()
										}
									}}
								/>
								<div className="pagination-input-icon" onClick={() => handlePageClick()}>
									<i className="uil uil-angle-right"></i>
								</div>
							</>
						}
					</div>

					{pageCount > 1 &&
						<ReactPaginate
							forcePage={currentPage}
							breakLabel={'...'}
							breakClassName={'break-me'}
							pageCount={pageCount}
							marginPagesDisplayed={marginPagesDisplayed}
							pageRangeDisplayed={pageRangeDisplayed}
							onPageChange={getCurrentPage}
							containerClassName={'pagination'}
							activeClassName={'active'}
							pageClassName={'page-item'}
						/>
					}
				</div>
			}
		</>
	)
}

export default FilterPagination
